import React from 'react';
import { Product } from '../../api-client';
import { ProductApplePay } from './ProductApplePay';

interface ApplePayBuyButtonProps {
  product: Product;
  quantity: number;
  selectedSizeId: number | null;
  selectedColorId: number | null;
  stock: number;
  onStockUpdate?: (colorId: number, sizeId: number, newStock: number) => void;
  onClose?: () => void;
}

export const ApplePayBuyButton: React.FC<ApplePayBuyButtonProps> = ({
  product,
  quantity,
  selectedSizeId,
  selectedColorId,
  stock,
  onStockUpdate,
  onClose,
}) => {
  const handleSuccess = () => {
    if (onStockUpdate && selectedColorId && selectedSizeId) {
      onStockUpdate(selectedColorId, selectedSizeId, Math.max(stock - quantity, 0));
    }
    onClose?.();
  };

  return (
    <ProductApplePay
      product={product}
      quantity={quantity}
      selectedSizeId={selectedSizeId}
      selectedColorId={selectedColorId}
      stock={stock}
      onSuccess={handleSuccess}
    />
  );
};

export default ApplePayBuyButton;
